/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	Input,
	OnInit,
	Optional,
	Self,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { CustomFieldDefinition } from 'src/app/app-data/models/CustomFieldDefinition';
import { MultiWrapperComponent } from 'src/app/modules/ticket-edit/components/multi-wrapper/multi-wrapper.component';
import { TicketEditBaseComponent } from 'src/app/modules/ticket-edit/components/ticket-edit-base/ticket-edit-base.component';
import { maintainParentErrorParity, maintainParentRequiredParity } from '../../custom-field-utils';

@Component({
	selector: 'custom-field-text',
	templateUrl: './custom-field-text.component.html',
	styleUrls: ['./custom-field-text.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomFieldTextComponent extends TicketEditBaseComponent implements OnInit {
	@Input() public customField: CustomFieldDefinition;

	constructor(
		@Self() @Optional() public control: NgControl,
		@Optional() public multiWrapper: MultiWrapperComponent,
		@Optional() protected cd: ChangeDetectorRef
	) {
		super(control, multiWrapper, cd);
	}

	public ngOnInit() {
		super.ngOnInit();

		maintainParentErrorParity(this.control.control, this.internalField, this.shutdownSubject);
		maintainParentRequiredParity(this.control.control, this.internalField, this.shutdownSubject);

		this.internalField.valueChanges.pipe(takeUntil(this.shutdownSubject)).subscribe((val) => {
			this.onChange(val);
		});
	}
}
